const RoundedCheckBig = (props: any) => (
    <svg width={80} height={80} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M40 6.667C21.6 6.667 6.667 21.6 6.667 40S21.6 73.333 40 73.333 73.334 58.4 73.334 40 58.4 6.666 40 6.666ZM30.967 54.3 19 42.333a3.32 3.32 0 0 1 0-4.7c1.3-1.3 3.4-1.3 4.7 0l9.634 9.6L56.267 24.3c1.3-1.3 3.4-1.3 4.7 0 1.3 1.3 1.3 3.4 0 4.7l-25.3 25.3c-1.267 1.3-3.4 1.3-4.7 0Z"
            fill="#2BB792"
        />
    </svg>
)

export default RoundedCheckBig
